// Normaliza a string`
// Remove caracteres especiais
export function sanitizeFileName(fileName: string) {
  return fileName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]|[^a-zA-Z0-9._-]/g, '');
}
